(function () {
  'use strict';

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantSelect = form.querySelector('[data-variant-select]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        if (idInput) idInput.value = variantSelect.value;
        var opt = variantSelect.options[variantSelect.selectedIndex];
        var avail = opt && opt.getAttribute('data-available') === 'true';
        var btn = form.querySelector('[type="submit"]');
        if (btn) {
          btn.disabled = !avail;
          btn.textContent = avail
            ? (btn.getAttribute('data-add-label') || 'Add to cart')
            : (btn.getAttribute('data-sold-label') || 'Sold out');
        }
        if (priceEl && opt) {
          var p = opt.getAttribute('data-price');
          if (p) priceEl.textContent = p;
        }
      });
    }
  });
})();
